import { SurfaceActionItem } from 'owa-surface-actions';

// Remove pinnedOnly actions like ToggleDarkMode from overflow when moved to surface on expanding window size.
// Some actions like ToggleDarkMode are pinned to surface in ItemActionsMenu.tsx and are displayed under special conditions,
// like ToggleDarkMode is displayed only if user has dark theme enabled.
// When browser window is sufficiently narrow, these actions disappear from surface and are moved to View option in overflow.
// When browser window is expanded, we need to remove these from the overflow and only make them available on surface.
export default function removePinnedOnlyActionFromOverflow(
    movedItem: SurfaceActionItem,
    overflowItems: SurfaceActionItem[]
): void {
    overflowItems.forEach(item => {
        if (item.key === 'View') {
            const indexOfMovedItem = item.subMenuProps.items.indexOf(movedItem);
            if (indexOfMovedItem > -1) {
                item.subMenuProps.items.splice(indexOfMovedItem, 1);
            }
        }
    });
}
